var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg101 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(10.315 10.376)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.043,
  cy: 10.04,
  fill: "#BEE4F8",
  rx: 10.043,
  ry: 10.04
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7CCDF9",
  d: "M1.603 15.484a10 10 0 0 0 5.448 1.604c5.546 0 10.042-4.495 10.042-10.04a10 10 0 0 0-1.603-5.444 10.03 10.03 0 0 1 4.596 8.436c0 5.545-4.497 10.04-10.043 10.04-3.54 0-6.651-1.83-8.44-4.596",
  opacity: 0.7
}))));
export { Svg101 as ReactComponent };